import * as React from "react"
import "../../styles/styles.sass"
import SidebarNavigation from "../../components/sidebarNavigation"
import TitleBar from "../../components/titleBar"
import ActivityIndicator from "../../components/activityIndicator"

// Markup
const ActivityIndicatorPage = () => {
  return (
    <main className="lighthouseView componentDetails activityIndicatorView">
      <title>Activity Indicator</title>
      <SidebarNavigation selectTab1="true"/>

      <div className="viewWindow">
        <TitleBar title="Activity Indicator" actions="" type="detail" backLink="/" backTitle="Components"/>

        <div className="viewContent">
          <ActivityIndicator size="large" color="action" />
          <ActivityIndicator size="large" color="tint" />
          <ActivityIndicator size="large" color="background" />
        </div>
      </div>
    </main>
  )
}

export default ActivityIndicatorPage
